export default "__VITE_ASSET__BQcnoBsp__"